import { memo } from 'react';
import styled from 'styled-components';
import type { MenuRootViewModelMaybe } from 'autogen/swagger/all';
import Menu from 'components/generic/menu';
import ItemsRenderer from './components/ItemsRenderer';

/* #region styles */
const StyledDefaultMenu = styled(Menu)`
    background-color: transparent;
    width: 100%;
`;
/* #endregion */

const CategoryAccordionSidebar = ({ model }: { model: MenuRootViewModelMaybe }) => {
    const { menuItems, text } = model;

    return (
        <StyledDefaultMenu size="sm">
            <ItemsRenderer menuItems={menuItems} headline={text} level={0} />
        </StyledDefaultMenu>
    );
};

export default memo(CategoryAccordionSidebar);
